import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import { formSettings } from './../settings';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../../../text/messages';
import WizardButtons from '../../../../../../components/wizard/navigator/buttons';
import { getYourRightsContent } from './assets/yourRights';
import { sign } from '../../../../../../reducers/signatures';
import { setProgressionProperties, getAdmin } from '../../../../../../reducers/onboarding';
import Signature from '../../../../../../components/signature';
import { getUserBackgroundChecks, saveUserBackgroundCheck, updateBackgroundCheck } from '../../../../../../reducers/backgroundCheck';
import { Signatures } from '../../../../../../utilities/signatureTypes';
import mixpanel from 'mixpanel-browser';
class BackgroundCheckFCRAStep extends React.Component {
    constructor(props) {
        super(props);

        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        mixpanel.track('WorkerOnboarding', { _data: { branch: 'employee', step: 'BackgroundCheckFCRAStep' } });

        const { admin, client, getAdmin, job, userId, backgroundCheck, getUserBackgroundChecks, saveUserBackgroundCheck } = this.props;
        const { fair_credit_reporting_act_signed } = backgroundCheck;

        if (!admin) {
            getAdmin(client.admin_id);
        }

        const createBackgroundCheckIfMissing = response =>
            response.length === 0 && saveUserBackgroundCheck(userId, job.id, { fair_credit_reporting_act_signed });

        if (!backgroundCheck.id) {
            getUserBackgroundChecks(userId, createBackgroundCheckIfMissing);
        }
    }

    submit(values, action) {
        const { role, job, sign, setProgressionProperties, backgroundCheck, updateBackgroundCheck } = this.props;
        const { fair_credit_reporting_act_signed } = backgroundCheck;

        sign(role, `${Signatures.types.BG_CHECK_FCRA.name}:${job.id}`, ({ id }) => {
            setProgressionProperties({ agreementBGfcra: true });

            if (!fair_credit_reporting_act_signed) {
                updateBackgroundCheck(backgroundCheck.id, { fair_credit_reporting_act_signed: id }, action);
                return;
            }

            action();
        });
    }

    render() {
        const { handleSubmit, onSubmit, back, submitting, admin, job } = this.props;
        if (!admin) {
            return null;
        }

        return (
            <form onSubmit={handleSubmit(values => this.submit(values, onSubmit))}>
                <div className="row section">
                    <div className="col-xs-12">
                        <strong>
                            <FormattedMessage id={'backgroundCheck.introText1'} defaultMessage={`A background check is required for this assignment.`} />
                        </strong>
                    </div>
                    <div className="col-xs-12">
                        <FormattedMessage
                            id={'backgroundCheck.introText2'}
                            defaultMessage={`We'll launch it once you've read and accepted the disclosures on this and the following pages.`}
                        />
                    </div>
                    <div className="col-xs-12">
                        <em>
                            <FormattedMessage
                                id={'backgroundCheck.introText2'}
                                defaultMessage={`(You may notice that the next few pages look similar to each other.  There's only one background check, but we're required to tell you about it in specific ways.  So that's why you may see some things more than once.)`}
                            />
                        </em>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <FormattedMessage id={'onboard2.backgroundCheckFCRA.intro1'} defaultMessage={'Summary of your rights'} tagName={'h5'} />
                    </div>
                </div>
                <div className="row section">
                    <div className="col-xs-12">
                        <div className="scrolled">{getYourRightsContent(admin)}</div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <Signature name={`${Signatures.types.BG_CHECK_FCRA.name}:${job.id}`} />
                    </div>
                </div>

                <WizardButtons disabled={submitting} back={{ action: back }} submit={{ message: <FormattedMessage {...messages.signAndContinue} /> }} />
            </form>
        );
    }
}

BackgroundCheckFCRAStep = reduxForm(formSettings)(BackgroundCheckFCRAStep);

const mapStateToProps = state => {
    const profile = state.identity.profile;
    return {
        role: state.identity.role,
        job: state.onboarding.job,
        admin: state.onboarding.admin,
        client: state.onboarding.client,
        userId: profile ? profile.id : undefined,
        backgroundCheck: state.backgroundCheck.current
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getAdmin: getAdmin,
            sign: sign,
            setProgressionProperties: setProgressionProperties,
            getUserBackgroundChecks,
            saveUserBackgroundCheck,
            updateBackgroundCheck
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(BackgroundCheckFCRAStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/employee/backgroundCheckFCRA.jsx